import { render, staticRenderFns } from "./FunnelsItem.vue?vue&type=template&id=5fa41d9d&scoped=true"
import script from "./FunnelsItem.vue?vue&type=script&lang=js"
export * from "./FunnelsItem.vue?vue&type=script&lang=js"
import style0 from "./FunnelsItem.vue?vue&type=style&index=0&id=5fa41d9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa41d9d",
  null
  
)

export default component.exports